import { Auth } from 'aws-amplify';

export const getToken = () => {
  let token;
  if (localStorage.getItem('access_token') !== null) {
    token = localStorage.getItem('access_token');
  } else {
    Auth.currentSession()
      .then(currentAuthUser => {
        const expiration_time = new Date(new Date().getTime() + 3600 * 1000);
        localStorage.setItem('expiration_time', expiration_time);
        localStorage.setItem('access_token', currentAuthUser.idToken.jwtToken);
        console.log(currentAuthUser);
        token = currentAuthUser.idToken.jwtToken;
      })
      .catch(err => console.log(err));
  }

  return token;
};
